import { FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';

interface AccountRequestRejectionReasonInputProps {
    errors: ValidationErrors;
    layout?: 'vertical' | 'horizontal';
    onChange: (rejectionReason: string) => void;
    rejectionReason: string;
}

export function AccountRequestRejectionReasonInput(props: Readonly<AccountRequestRejectionReasonInputProps>) {
    const language = getSelectedLanguage();

    return (
        <FormSection isBorderless>
            <FormGroup
                hasErrors={props.errors.has('rejectionReason')}
                isRequired={true}
                label={language.accountRequest.rejectionReason}
                layout={props.layout}
            >
                <TextInput
                    error={getValidationErrorTranslation(props.errors.get('rejectionReason'))}
                    onChange={(e) => props.onChange(e.target.value)}
                    value={props.rejectionReason}
                />
            </FormGroup>
        </FormSection>
    );
}
